'use client';

import { c as _c } from "react/compiler-runtime";
import * as SolidIcon from '@heroicons/react/20/solid';
import * as OutlineIcon from '@heroicons/react/24/outline';
import { type ReactNode } from 'react';
import { cn } from '@src/utils/tailwind';
export const IconNames = ['CheckCircleIcon', 'CheckIcon'] as const;
export const IconTypes = ['outline', 'solid'] as const;
interface IconTextProps {
  children: ReactNode;
  iconName: (typeof IconNames)[number];
  iconType?: (typeof IconTypes)[number];
  iconColor?: string;
  iconSize?: number;
  className?: string;
}
export const IconText = props => {
  const $ = _c(13);
  const {
    children,
    iconName: t0,
    iconColor: t1,
    iconType: t2,
    iconSize: t3,
    className
  } = props;
  const iconName = t0 === undefined ? "CheckCircleIcon" : t0;
  const iconColor = t1 === undefined ? "#131232" : t1;
  const iconType = t2 === undefined ? "solid" : t2;
  const iconSize = t3 === undefined ? 16 : t3;
  const IconComponent = iconType === "outline" ? OutlineIcon[iconName] : SolidIcon[iconName];
  let t4;
  if ($[0] !== className) {
    t4 = cn("relative flex items-center gap-3", className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `${iconSize}px`;
  const t6 = `${iconSize}px`;
  let t7;
  if ($[2] !== t5 || $[3] !== t6) {
    t7 = {
      height: t5,
      width: t6
    };
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== IconComponent || $[6] !== iconColor || $[7] !== t7) {
    t8 = <div className="flex items-center justify-center"><IconComponent style={t7} color={iconColor} /></div>;
    $[5] = IconComponent;
    $[6] = iconColor;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== children || $[10] !== t4 || $[11] !== t8) {
    t9 = <div className={t4}>{t8}{children}</div>;
    $[9] = children;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};